import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = () => api.get("/products").then((r) => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);
export const getGlncProducts = () => api.get("/glnc/products").then((r) => r.data);
export const getCollections = () => api.get("/collections").then((r) => r.data);
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
export const createCheckout = (items) =>
  api.post("/checkout", { items }).then((r) => r.data);
